module.exports = __webpack_public_path__ + "static/media/complexPic13.4665e3cd.png";